const state = {
  files: [],
  videos: [],
  images: [],
  isInitialized: false,
  loading: false,
};

const getters = {};

const actions = {
  getFiles(context, payload) {
    return this._vm.axios.get(
      // eslint-disable-next-line
      '/client/lms/fetch-images', {
        params: payload
      }
    );
  },
  setIntialize({commit},payload){
    commit('setIsInitialized', payload);
  },
  setLoading({ commit }, payload) {
    commit('setLoading', payload);
  },
  setFiles({commit},payload){
    commit('setFiles',payload)
  },
  setImages({commit},payload){
    const images = payload.filter(f => (f.type === 'image'))

    commit('setImages',images)
  },
  setVideos({commit},payload){
    const videos =  payload.filter(f => (f.type === 'video'))

    commit('setVideos',videos)
  }
};

const mutations = {
  setListCurriculums: (st, data) => {
    st.listCurriculums = data;
  },
  setFiles: (st, data) => {
    // eslint-disable-next-line no-param-reassign
    st.files = data;
  },
  setVideos: (st, data) => {
    // eslint-disable-next-line no-param-reassign
    st.videos = data;
  },
  setImages: (st, data) => {
    // eslint-disable-next-line no-param-reassign
    st.images = data;
  },
  setLoading: (st, data) => {
    st.loading = data;
  },
  setIsInitialized: (st,data) => {
    st.isInitialized = data
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
